import React from 'react';
import classNames from 'classnames';

interface TableProps {
  children: React.ReactNode;
  className?: string;
}

export const Table: React.FC<TableProps> = ({ children, className }) => (
  <div className="table-container">
    <table className={classNames('min-w-full divide-y divide-gray-700', className)}>
      {children}
    </table>
  </div>
);

export const TableHead: React.FC<TableProps> = ({ children, className }) => (
  <thead className={classNames('bg-gray-800', className)}>
    {children}
  </thead>
);

export const TableBody: React.FC<TableProps> = ({ children, className }) => (
  <tbody className={classNames('divide-y divide-gray-700 bg-gray-800', className)}>
    {children}
  </tbody>
);

interface TableRowProps extends TableProps {
  onClick?: () => void;
}

export const TableRow: React.FC<TableRowProps> = ({ children, className, onClick }) => (
  <tr className={classNames('hover:bg-gray-750', className)} onClick={onClick}>
    {children}
  </tr>
);

interface TableCellProps extends TableProps {
  header?: boolean;
}

export const TableCell: React.FC<TableCellProps> = ({ children, className, header }) => {
  const Component = header ? 'th' : 'td';
  return (
    <Component
      className={classNames(
        'px-6 py-4 text-sm',
        header
          ? 'font-medium text-gray-400 text-left uppercase tracking-wider'
          : 'text-gray-300 whitespace-nowrap',
        className
      )}
    >
      {children}
    </Component>
  );
};

export default Table;
